import { SelectionMode } from '@fluentui/react';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { NotificationsTarget, useNotificationsManager } from '../../contexts/notificationContext';
import '../../css/immocom.css';
import { DataLot } from '../../data/DataLot';
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';

const DetailsListLot = (props) => {

    // CONTEXTS
    const { dismiss, extract, load } = useNotificationsManager();

    // PROPS
    const {
        activeItems = [], // liste des lots à présélectionner
        idOperation = undefined,
        onSelectionChanged = items => null,  // renvoi la liste des lots sélectionnéss
        scrollablePaneStyles = {}
    } = props;

    // CONSTANTES

    // STATES
    const [_items, _setItems] = useState([]);

    // REFS

    // MEMOS

    // METHODS
    const _chargementDonnees = useCallback(() => {
        const id = load("Chargement des lots en cours...");
        DataLot._listeDesLOTS(idOperation, true).then(response => {
            const onSuccess = () => {
                const lots = response.reponseAPIobjet || [];
                _setItems(lots);
            };
            const onError = (result) => extract(result, NotificationsTarget.main);
            Immocom.checkFetchResponse(response, onSuccess, onError);
            dismiss(id);
        });
    }, [idOperation]);

    const _onSelectionChanged = useCallback((items) => {
        if (typeof onSelectionChanged === "function")
            onSelectionChanged(items);
    }, [onSelectionChanged]);

    // EFFECTS (ComponentDidMount + ComponentDidUpdate)
    // Recharger les données lorsqu'une dépendance change
    useEffect(() => {
        if (!!idOperation)
            _chargementDonnees();
    }, [idOperation]);

    // UI
    const _columns = useMemo(() => {
        return [
            {
                key: "numero",
                maxWidth: 85,
                minWidth: 60,
                name: "N°"
            }, {
                key: "prixHT",
                maxWidth: 100,
                minWidth: 80,
                name: "Prix HT"
            }, {
                key: "idReservation",
                maxWidth: 100,
                minWidth: 80,
                name: "IdReservation"
            }
        ];
    }, []);

    const _menuItems = useMemo(() => {
        if (!Array.isArray(activeItems) || activeItems.length !== 1) return null;
        else {
            const name = `Lot selectionné : ${activeItems[0].numero}`;
            return [{ key: "selectionDetails", name }];
        }

    }, [activeItems]);

    // RENDER
    return <EUIDetailsList
        activeItems={activeItems}
        columns={_columns}
        getKey={item => `${item.idOperation};${item.idLotCommercial}`}
        items={_items}
        menuItems={_menuItems}
        onSelectionChanged={_onSelectionChanged}
        selectionMode={SelectionMode.multiple}
        scrollablePaneStyles={scrollablePaneStyles}
    />;

};

export default DetailsListLot;